import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import CustomerEnquiryContMain from "presentation/view/container/CustomerEnquiry/CustomerEnquiryContMain";

CommonEntrypoint(<CustomerEnquiryContMain/>)